import {Indexer} from 'rlink-cms/indexing';

export class PromotionTileIndexer extends Indexer {

  itemData (content) {
    return content.data;
  }

  get sortKey () {
    return ['priority'];
  }

  get linkedContentPaths() {
    return this.items.map(item => item.get('backgroundPath')).filter(bg => bg);
  }

}


PromotionTileIndexer.contentClassName = 'PromotionTile';

export default async function (command, repo) {
  await repo.submit(
    await PromotionTileIndexer.index(command, repo)
  );
}



// WEBPACK FOOTER //
// ./apps/ingame.companyofheroes.com/src/indexers.js